// extracted by mini-css-extract-plugin
export var modalFooter = "_md-0";